import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { ContentPlanRootState as S } from '../../../elements/contentPlan/store';
import { Functions } from '../../../types/types';
import { ElementAction } from '../../../elements/elementAction';
import { Metadata } from '../../../types/Metadata';
import { ViewType } from '../../../enums/ViewType';
import { NodeType } from '../../../enums/NodeType';

import { Op } from '../../../enums/Op';
import { ItemStatus } from '../../../enums/ItemStatus';

const statusesLessThan100 = Object.values(ItemStatus).filter(
  value => typeof value === 'number' && value < 100
);

const getSearchConditions = (data: Partial<Metadata>) => {
  const defaultFilters = [];

  defaultFilters.push({
    field: 'Item.itemType',
    conditions: [{ [Op.is]: ['content'] }]
  });

  defaultFilters.push({
    field: 'Item.expiryDate',
    conditions: [
      { includeBlanks: true },
      { [Op.greaterThan]: new Date().toISOString().split('T')[0] }
    ]
  });

  defaultFilters.push({
    field: 'Item.status',
    conditions: [
      {
        [Op.notRefIds]: [
          ...statusesLessThan100.map(status => `status:${status}`),
          'blanks'
        ]
      }
    ]
  });
  return defaultFilters;
};

const searchItems =
  (
    data: Partial<Metadata>,
    query: string,
    page: number
  ): ElementAction<Functions, S> =>
  async (dispatch, getState, { getAPI }) => {
    const { searchData } = getAPI();
    const queryCondition = !isNaN(Number.parseInt(query))
      ? {
          field: 'Item.itemId',
          conditions: [
            {
              equals: query
            }
          ]
        }
      : {
          field: 'Item.title',
          conditions: [
            {
              contains: query
            }
          ]
        };
    const searchConditions = getSearchConditions(data);

    const queryFilters = [queryCondition, ...searchConditions];

    const spayload = {
      view: {
        props: {
          type: ViewType.Tabular
        },
        card: {
          props: {
            data: NodeType.Item
          }
        },
        dataSchema: undefined
      },
      filters: queryFilters,
      limit: (page + 1) * 25
    };

    const r = await searchData(spayload as any);
    if (r?.data) {
      return {
        data: r.data,
        pages: Math.floor(r.info.count / 25)
      };
    }
    return null;
  };

export const useActions = () => {
  const dispatch: Dispatch<any> = useDispatch();
  return {
    searchItems: async (
      data: Partial<Metadata>,
      query: string,
      limit: number
    ) => await dispatch(searchItems(data, query, limit))
  };
};
